import { Component, OnInit, inject } from '@angular/core';
import { jstDateString, nextJstDateString } from '../../shared/utils/jst-date';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { QuestionaryService } from '../../core/services/questionary.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';

const SESSION_KEY = 'questionary_select_studio_id';

@Component({
    selector: 'app-questionary',
    imports: [FormsModule, DecimalPipe],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-marketing"></i> {{ selectedStudio?.name }} アンケート集計</span>
    </div>
    <div class="card-body">
      <form novalidate name="myForm">
        <div class="col-md-12 row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">店舗</label>
                <select class="form-control" [(ngModel)]="selectedStudio" name="studio" (ngModelChange)="onStudioChange()">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (s of studios; track s.id) {
                    <option [ngValue]="s">{{ s.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">区分コース</label>
                <select class="form-control" [(ngModel)]="studioPlanFilter" name="studioPlanFilter" (ngModelChange)="updateList()">
                  <option [ngValue]="null">-- すべて --</option>
                  @for (p of studioPlans; track p.id) {
                    <option [ngValue]="p">{{ p.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">性別</label>
                <select class="form-control" [(ngModel)]="sexFilter" name="sexFilter" (ngModelChange)="updateList()">
                  <option value="">-- すべて --</option>
                  <option value="0">男性</option>
                  <option value="1">女性</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">年代</label>
                <select class="form-control" [(ngModel)]="ageRangeFilter" name="ageRangeFilter" (ngModelChange)="updateList()">
                  <option value="">-- すべて --</option>
                  <option value="10">10代以下</option>
                  <option value="20">20代</option>
                  <option value="30">30代</option>
                  <option value="40">40代</option>
                  <option value="50">50代</option>
                  <option value="60">60代</option>
                  <option value="70">70代</option>
                  <option value="80">80代</option>
                  <option value="90">90代</option>
                  <option value="100">100代</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">在籍状況</label>
                <select class="form-control" [(ngModel)]="statusFilter" name="statusFilter" (ngModelChange)="updateList()">
                  <option value="">-- すべて --</option>
                  <option value="0">在籍中</option>
                  <option value="1">停止</option>
                  <option value="2">停止(除名)</option>
                  <option value="3">削除済</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">会員登録日</label>
                <div class="bisected-input-wrap">
                  <div class="bisected-input">
                    <input type="date" class="form-control" [(ngModel)]="dateFrom" name="dateFrom" (ngModelChange)="retrieveData()">
                  </div>
                  <div><span>&nbsp;~&nbsp;</span></div>
                  <div class="bisected-input">
                    <input type="date" class="form-control" [(ngModel)]="dateTo" name="dateTo" (ngModelChange)="retrieveData()">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-2">
            <div class="form-group row">
              <div class="col-md-12">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="hideUnanswered" id="hide_unanswered" name="hide_unanswered" (ngModelChange)="updateList()">
                  <label class="custom-control-label" for="hide_unanswered">サンプル数が0のアンケート結果を表示しない。</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12"><hr></div>
      </form>
    </div>
    <div class="card-body">
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (selectedStudio && !searching && summariesList.length === 0) {
        <span>該当するデータはありません</span>
      }
      @for (entry of summariesList; track entry.questionaryContent) {
        <div class="col-md-12" style="margin-bottom: 20px;">
          <div style="margin-bottom: 10px;">
            <i class="fa s-icon-help" aria-hidden="true"></i>&nbsp;{{entry.questionaryContent}}
          </div>
          <div class="col-md-12">
            <div class="row align-items-end">
              <table class="table table-responsive-sm table-borderless table-ptb-0">
                <thead>
                  <tr class="table-secondary">
                    <td class="pt-0 pb-0" colspan="5"><small>選択肢</small></td>
                    <td class="pt-0 pb-0" style="text-align: right;"><small>回答数</small></td>
                    <td class="pt-0 pb-0" style="text-align: right;"><small>%</small></td>
                  </tr>
                </thead>
                <tbody>
                  @for (row of entry.summaries; track row.selectColumn) {
                    <tr class="border-bottom border-light">
                      <td colspan="5">{{row.selectColumn}}</td>
                      @if (row.selectColumn !== 'サンプル数' || row.idNumber !== 0) {
                        <td><span class="pull-right">{{row.idNumber | number}}</span></td>
                        <td><span class="pull-right">{{row.percentage | number:'1.1-1'}}</span></td>
                      } @else {
                        <td><span class="pull-right"> - </span></td>
                        <td><span class="pull-right"> - </span></td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
  `
})
export class QuestionaryComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private route = inject(ActivatedRoute);
  private studioService = inject(StudioService);
  private questionaryService = inject(QuestionaryService);
  private studioSelection = inject(StudioSelectionService);

  studios: any[] = [];
  studioPlans: any[] = [];
  selectedStudio: any = null;
  searching = false;
  dateFrom = '2015-09-01';
  dateTo = '';
  studioPlanFilter: any = null;
  sexFilter = '';
  ageRangeFilter = '';
  statusFilter = '';
  hideUnanswered = false;

  private baseData: any[] = [];
  summariesList: { questionaryContent: string; summaries: any[] }[] = [];

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('データ集計', 's-icon-marketing');
    this.dateTo = jstDateString();
    this.studios = await this.studioService.list('all') ?? [];
    const routeStudioId = this.route.snapshot.paramMap.get('studioId');
    const restored = routeStudioId
      ? this.studios.find(s => String(s.id) === routeStudioId)
      : this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      this.studioSelection.save(restored, SESSION_KEY);
      await this.retrieveData();
    }
  }

  async onStudioChange(): Promise<void> {
    this.summariesList = [];
    this.studioPlans = [];
    this.studioPlanFilter = null;
    if (!this.selectedStudio) { this.studioSelection.clear(SESSION_KEY); return; }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.retrieveData();
  }

  async retrieveData(): Promise<void> {
    if (!this.selectedStudio || !this.dateFrom || !this.dateTo) return;

    const studioData: any = await this.studioService.list(this.selectedStudio.id);
    this.studioPlans = studioData?.studioPlans ?? [];
    this.studioPlanFilter = null;

    const endStr = nextJstDateString(this.dateTo);
    if (!endStr) return;

    this.searching = true;
    try {
      this.baseData = await this.questionaryService.getQuestionaryResultByStudioId(
        this.selectedStudio.id, this.dateFrom, endStr
      ) ?? [];
      this.updateList();
    } finally {
      this.searching = false;
    }
  }

  updateList(): void {
    if (!this.baseData.length) { this.summariesList = []; return; }

    const noFilterPlan = this.studioPlanFilter == null;
    const noFilterSex = this.sexFilter === '' || this.sexFilter === undefined;
    const noFilterAge = this.ageRangeFilter === '' || this.ageRangeFilter === undefined;
    const noFilterStatus = this.statusFilter === '' || this.statusFilter === undefined;

    const data = this.baseData.filter(v =>
      (noFilterPlan || v['questionaryResults.member.studioPlanId'] === Number(this.studioPlanFilter.id)) &&
      (noFilterSex || v['questionaryResults.member.sex'] === Number(this.sexFilter)) &&
      (noFilterAge || v['questionaryResults.member.ageRange'] === Number(this.ageRangeFilter)) &&
      (noFilterStatus || v['questionaryResults.member.status'] === Number(this.statusFilter))
    );

    const frame = this.createFrame(this.baseData);
    const wrap = this.createQuestionarySummary(data, frame);

    this.summariesList = Object.entries(wrap)
      .map(([questionaryContent, summaries]: [string, any]) => ({ questionaryContent, summaries }))
      .filter(entry => {
        if (!this.hideUnanswered) return true;
        const last = entry.summaries[entry.summaries.length - 1];
        return last?.idNumber !== 0;
      });
  }

  private createFrame(data: any[]): Record<string, any[]> {
    const frame: Record<string, any[]> = {};
    data.forEach(v => {
      if (!frame[v.questionaryContent]) frame[v.questionaryContent] = [];
      if (!frame[v.questionaryContent].some((q: any) => v.selectColumn === q.selectColumn)) {
        frame[v.questionaryContent].push({ selectColumn: v.selectColumn, idNumber: 0, percentage: 0 });
      }
    });
    return frame;
  }

  private createQuestionarySummary(data: any[], frame: Record<string, any[]>): Record<string, any[]> {
    const summary = data.reduce((result: any[], current: any) => {
      const element = result.find(p => p.id === current.id);
      if (element) {
        element.idNumber += current['questionaryResults.member.count'];
      } else {
        result.push({
          id: current.id,
          questionaryContent: current.questionaryContent,
          selectColumn: current.selectColumn,
          idNumber: current['questionaryResults.member.count'],
          percentage: 0,
          questionaryGroupId: current.questionaryGroupId,
        });
      }
      return result;
    }, []);

    const total = data.reduce((result: any[], current: any) => {
      const totalElement = result.find(p => p.questionaryGroupId === current.questionaryGroupId);
      if (totalElement) {
        totalElement.idNumber += current['questionaryResults.member.count'];
      } else {
        result.push({
          questionaryContent: current.questionaryContent,
          selectColumn: 'サンプル数',
          idNumber: current['questionaryResults.member.count'],
          percentage: 100,
          questionaryGroupId: current.questionaryGroupId,
        });
      }
      return result;
    }, []);

    total.forEach(v => { frame[v.questionaryContent].push(v); });

    summary.forEach(v => {
      const target = frame[v.questionaryContent].find((f: any) => v.selectColumn === f.selectColumn);
      if (target) {
        target.selectColumn = v.selectColumn;
        target.idNumber = v.idNumber;
        const totalRow = frame[v.questionaryContent][frame[v.questionaryContent].length - 1];
        target.percentage = totalRow.idNumber > 0 ? (v.idNumber / totalRow.idNumber) * 100 : null;
      }
    });

    return frame;
  }
}
